import React from "react";
import Header from "../components/Header/Header";

const HeaderNavigation = () => {
	return <Header />;
};

export default HeaderNavigation;
